import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BroadcastService",
  controller: "TaskProgram",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "GetItemById",
  "GetPageContentByConditions",
  "FindByConditions",
  "AddItemList",
  "UpdateItemList"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const TaskProgramApi = ZJApi.defineNewApi("TaskProgramApi", factory);

export default TaskProgramApi;
